// removed by extract-text-webpack-plugin
module.exports = {"page":"_3zMYE","breadcrumbs":"_1LM0I","breadcrumb":"_1WZf8","periods":"_4Tm02","gap":"_3QA-y","button":"J8w3H"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Timeline.css
// module id = 866
// module chunks = 0